import DatePill from "app/components/AdaptiveDatePicker/DatePill";
import { Calendar } from "app/components/Calendar";
import { CalendarIcon } from "app/components/Icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import clsx from "clsx";
import { format } from "date-fns";
import React from "react";
import { useDispatch } from "react-redux";
import { actions } from "../../redux/slice";
import { getSafeFormattedDate } from "../../helper";

interface CustomProps {
  startDate: string;
  endDate: string;
}



const DateSelection: React.FC<CustomProps> = ({ endDate, startDate }) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [error, setError] = React.useState("");
  const clearStartDate = () => {
    setError("");
    dispatch(actions.updateFormValue({ key: "startDate", value: "" }));
  };

  const clearEndDate = () => {
    setError("");
    dispatch(actions.updateFormValue({ key: "endDate", value: "" }));
  };

  const handleSelect = (range: { from?: Date; to?: Date } | undefined) => {
    if (!range) return;
    if (range.from) {
      const startDate = format(range.from, "yyyy-MM-dd");
      dispatch(actions.updateFormValue({ key: "startDate", value: startDate }));
    }

    
    if (range.to && range.from) {
      const diffInDays =
        (range.to.getTime() - range.from.getTime()) / (1000 * 60 * 60 * 24);

      if (diffInDays < 7) {
        setError("Minimal sprint duration is 1 week");
        return;
      }

      const endDate = format(range.to, "yyyy-MM-dd");
      dispatch(actions.updateFormValue({ key: "endDate", value: endDate }));
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="relative">
          <div className={`flex flex-col gap-[6px] `}>
            <label className={`text-xs leading-[18px] text-[#79808A] `}>
              Start - End dates
            </label>
            <button
              className={`flex items-center justify-between text-sm leading-[21px] gap-[8px] h-[48px] flex-row border rounded-[4px] py-[16px] px-[10px] $${
                open ? "!border-[#79808A]" : "border-[#E9ECF2]"
              }  `}
            >
                <span>
                  {startDate ? (
                    format(startDate, "dd MMM, yyyy") 
                  ) : (
                    <span className="text-gray-300">Start date</span>
                  )}{" "}
                  -{" "}
                  {endDate ? (
                    format(endDate, "dd MMM, yyyy")
                  ) : (
                    <span className="text-gray-300">End date</span>
                  )}
                </span>
              <CalendarIcon size={20} color="#79808A" />
            </button>
          </div>
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-[223px] px-0 py-2 bg-white border border-[#E9ECF2] rounded-md"
      >
        <div className="flex items-center justify-between h-[39px] px-4 border-b border-[#E9ECF2] ">
          <DatePill
            date={getSafeFormattedDate(startDate)}
            onClear={clearStartDate}
            iconShow={!!startDate}
            className="!p-0"
            placeHolder="Start date"
            textClassName={clsx(!startDate && "opacity-50"," !text-[10px]")}
            hideCalenderIcon
            iconSize={16}
          />
          -
          <DatePill
            date={getSafeFormattedDate(endDate)}
            onClear={clearEndDate}
            iconShow={!!endDate}
            className="!p-0"
            placeHolder="End date"
            textClassName={clsx(!startDate && "opacity-50", " !text-[10px]")}
            hideCalenderIcon
            iconSize={16}
          />
        </div>
        <div className="flex items-center justify-center py-4 px-4 w-full ">
          <Calendar
            mode="range"
            selected={{
              from: startDate ? new Date(startDate) : undefined,
              to: endDate ? new Date(endDate) : undefined,
            }}
            onSelect={handleSelect}
            required={true}
            className="w-full"
            monthGridClassName="w-full"
            isDisablePastDate
          />
          
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DateSelection;
